import React, { useRef, useImperativeHandle, forwardRef } from "react";
import classNames from "classnames";
import close from "@/assets/close.svg";
import styles from "./index.module.scss";
import { FixDrawer } from "@/elements-react/fix-drawer";
import { FixButton } from "@/elements-react/fix-button";
import { Icon } from "@/elements-react/fix-icon";

export type DrawerPanelHandle = {
  show: () => void;
  hide: () => void;
};

type DrawerPanelProps = React.PropsWithChildren<{
  state?: "hidden" | "visible";
  onClose?: () => void;
  isOutsideCloseButtonVisible?: boolean;
  customDrawerVariant?: "default" | "wide";
}>;

const DrawerPanel = forwardRef<DrawerPanelHandle, DrawerPanelProps>(({ state = "hidden", onClose, children, isOutsideCloseButtonVisible = true, customDrawerVariant = "default" }, ref) => {
  const drawerRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    show: () => drawerRef.current?.show(),
    hide: () => drawerRef.current?.hide(),
  }));

  const handleClose = async () => {
    onClose?.();
  };

  return (
    <div className={classNames(styles.root)}>
      <FixDrawer
          placement="start"
          ref={drawerRef}
          open={state === "visible"}
          onClose={handleClose}
          isOutsideCloseButtonVisible={isOutsideCloseButtonVisible}
          customVariant={customDrawerVariant}
      >
        <div className={styles.box}>{children}</div>
      </FixDrawer>
    </div>
  );
});

export default DrawerPanel;
